import type { DragEventHandler } from 'react'
import { useT } from 'flyt/lib/language/language'
import { GripVerticalIcon } from 'flyt/ui/Icons/Icons'

/** Shared, stateless affordance for table headers and the column settings. */
export function ColumnDragHandle({ label, active, axis, onMove, onDragStart, onDragEnd }: {
  label: string
  active: boolean
  axis: 'horizontal' | 'vertical'
  onMove: (offset: number) => void
  onDragStart: DragEventHandler<HTMLElement>
  onDragEnd: DragEventHandler<HTMLElement>
}) {
  const t = useT('common')
  return <button type="button" draggable
    aria-label={t('table.moveColumn', { column: label })}
    title={t(axis === 'horizontal' ? 'table.moveHint.horizontal' : 'table.moveHint.vertical')}
    onDragStart={onDragStart} onDragEnd={onDragEnd}
    onClick={(event) => event.stopPropagation()}
    onKeyDown={(event) => {
      const backward = axis === 'horizontal' ? 'ArrowLeft' : 'ArrowUp'
      const forward = axis === 'horizontal' ? 'ArrowRight' : 'ArrowDown'
      if (event.key !== backward && event.key !== forward) return
      event.preventDefault()
      onMove(event.key === forward ? 1 : -1)
    }}
    className={`flex shrink-0 cursor-grab items-center justify-center rounded p-0.5 text-text-muted transition-opacity hover:bg-surface-muted hover:text-text active:cursor-grabbing focus-visible:outline-2 focus-visible:outline-accent group-hover/column:opacity-100 group-focus-within/column:opacity-100 [@media(hover:none)]:opacity-100 ${active ? 'opacity-100' : 'opacity-0'}`}>
    <GripVerticalIcon width={16} height={16} />
  </button>
}
